// The fetched record is authoritative; navigation and favorites may have old labels.
export function clientName(cliente, navigation = {}) {
  if (
    cliente?.ID &&
    (!navigation.idC || Number(cliente.ID) === Number(navigation.idC))
  )
    return cliente.RagioneSociale || "";
  return navigation.RagioneSociale || "";
}
